import dotenv from "dotenv";
dotenv.config();

const PORTAL_URL = process.env.PORTAL_URL || "http://cnb.secondcompany.nl";

const CAPI_URL =
  process.env.CAPI_URL || "https://capi-lisse-development.cnb.nl/odata";
const AUTHORITY_URL =
  process.env.AUTHORITY_URL || "https://capi-idserver-lisse-development.cnb.nl";
const CLIENT_ID = process.env.CLIENT_ID || "MijnCNB";
const ACCOUNTMANAGEMENT_URL =
  process.env.ACCOUNTMANAGEMENT_URL ||
  "https://capi-accountmanagement-lisse-development.cnb.nl";

const ENV_NAME = process.env.ENV_NAME || "development";
const isDev = process.env.ENV_NAME === "development";

const configs = {
  LOCAL_API_URI: `${isDev ? "http://localhost:5000" : ""}/api`,
  CAPI_URL,
  PORTAL_URL,
  AUTHORITY_URL,
  CLIENT_ID,
  ACCOUNTMANAGEMENT_URL,
  ENV_NAME,
};

const getVar = (name: string, optional?: string) => {
  const isInStorage = localStorage.getItem(name);
  if (isInStorage) {
    return localStorage.getItem(name);
  }
  // return getVar(name);
  return configs[name];
};

export const PAGE_SIZE = 10;

export const PAGE_SIZE_OPTIONS = [
  {
    label: 10,
    value: 10,
  },
  {
    label: 50,
    value: 50,
  },
  {
    label: 100,
    value: 100,
  },
  {
    label: 200,
    value: 200,
  },
];

export const ROLE_IDS = {
  Buying: "Buyer",
  Aankoop: "Buyer",
  Buyer: "Buyer",
  Selling: "Seller",
  Verkoop: "Seller",
  Seller: "Seller",
  Grower: "Supplier",
  Kweker: "Supplier",
  Supplier: "Supplier",
};

export const CUSTOM_SETTINGS = {
  accountStatements: "Rekeningoverzichten",
  allNotifications: "Meldingen",
  areaStatements: "Areaalopgaven",
  cultivationAdvice: "Mijn_teeltadvies",
  deliveries: "Leveringen",
  deliveryNotes: "Mijn_leveringen",
  inspectionReport: "KPB_ontvangstrapport",
  invoices: "Facturen",
  myCultivationAdvice: "Teeltadvies",
  myNotifications: "Mijn_meldingen",
  orders: "Orders",
  qualityReport: "KPB_Keurrapporten",
  receiptsReturns: "Ontvangsten",
};

export const modalTypes = {
  areaStatement: "AreaalOverzicht",
  deliveries: "Leveringen",
};

export default getVar;
